module.exports = __webpack_public_path__ + "img/tebogo-profile-min.05b7953a.jpg";